<template>
  <div class="page-wrapper">
    <div class="page">
      <!-- 顶部区域 -->
      <div class="header">
        <div class="header-content">
          <div class="logo-container">
            <img class="logo" :src="require('@/assets/images/logo.png')" alt="logo" />
            <span class="title">火漫漫画</span>
          </div>
        </div>
      </div>

      <!-- 主要内容区域 -->
      <div class="main-content">
        <div class="hero-section">
          <div class="phone-container">
            <div class="phone-frame">
              <div class="notch-background"></div>
              <img class="phone-screenshot" :src="require('@/assets/images/image copy.png')" alt="App截图" />
              <img class="phone-image" :src="require('@/assets/images/image.png')" alt="App展示" />
            </div>
          </div>
          <div class="hero-text">
            <h1>火漫漫画</h1>
            <div class="description">
              <p>精彩漫画看不停</p>
              <p>这是一个专门为漫画迷们打造的追漫神器</p>
              <p>且画质清晰，超级的方便好用</p>
            </div>
            <div class="download-buttons">
              <a @click.prevent="showNotAvailableMessage('iOS')" href="#" class="download-btn">
                <img :src="require('@/assets/images/apple.png')" alt="iOS下载" class="download-img" />
              </a>
              <a href="https://sj.qq.com/appdetail/com.qufengmanku.ydmhdq?fromcase=70051&g_f=1182517&scenevia=XQYFX&from_wxz=1" target="_blank" class="download-btn">
                <img :src="require('@/assets/images/android.png')" alt="Android下载" class="download-img" />
              </a>
            </div>
          </div>
        </div>

        <!-- 功能介绍区域 -->
        <div class="features-section">
          <h2 class="section-title">功能介绍</h2>
          <p class="section-subtitle">非常好用的一款漫画阅读软件可以为你带来更为舒适清爽的看漫画新体验，<br>随时随地地开启漫画阅读模式。</p>
          
          <div class="features-container">
            <div class="feature-column">
              <h3>软件特色</h3>
              <div class="feature-text">
                1、为了让你不断推送各种漫画资源，你可以随时观看你喜欢的内容；<br />
                2、它每天都会不断更新，这肯定会让大家很享受，观看体验非常舒适；<br />
                3、不断上架各种漫画，让用户随时随地观看自己喜爱的资源；
              </div>
              <h3 class="mt-20">应用优势</h3>
              <div class="feature-text">
                1.画质清晰，高清画面。<br />
                2.超级完整的漫画库，更新速度非常快。
              </div>
            </div>

            <div class="feature-phone">
              <div class="phone-preview">
                <img :src="require('@/assets/images/shouji.png')" alt="手机展示" class="phone-frame" />
                <img :src="require('@/assets/images/fenlei.png')" alt="功能展示" class="phone-content" />
              </div>
            </div>

            <div class="feature-column">
              <h3>软件亮点</h3>
              <div class="feature-text">
                1、漫画的封面清晰可见，用户可以随意浏览和选择自己感兴趣的漫画；<br />
                2、免费的漫画新内容还是很多样化的，各种很精彩的资源全部都能找到；<br />
                3、漫画还分为不同的板块，如完结、连载、免费等等，方便用户查找自己感兴趣的内容；
              </div>
            </div>
          </div>
        </div>

        <!-- 底部链接 -->
        <div class="bottom-links">
          <a @click.prevent="openDocument('privacy')" href="#" target="_blank">隐私政策</a>
          <a @click.prevent="openDocument('terms')" href="#" target="_blank">使用条款</a>
        </div>

        <!-- 页脚 -->
        <footer class="footer">
          <p>©湖南趣风漫酷网络科技有限公司 </p>
          <p>湘 ICP 备 2024063123 号 - 4A</p>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      baseWidth: 1440, // 设计稿基准宽度
    }
  },
  methods: {
    showNotAvailableMessage(platform) {
      alert(`${platform}版本正在上架审核中，敬请期待！`);
    },
    openDocument(type) {
      // 使用 public 目录下的文件
      const pdfPath = type === 'privacy' 
        ? '/docs/火漫漫画隐私政策.pdf'
        : '/docs/火漫漫画使用条款.pdf';
      
      // 在新窗口打开PDF，添加#view=FitH参数来优化预览
      window.open(pdfPath + '#view=FitH', '_blank');
    },
    updatePageScale() {
      // 确保DOM已加载
      this.$nextTick(() => {
        const page = document.querySelector('.page');
        const wrapper = document.querySelector('.page-wrapper');
        
        if (!page || !wrapper) return;
        
        // 计算缩放比例
        const scale = Math.min(window.innerWidth / this.baseWidth, 1);
        
        // 应用缩放
        page.style.transform = `scale(${scale})`;
        
        // 计算缩放后的实际高度
        const scaledHeight = page.scrollHeight * scale;
        
        // 设置包装容器的高度
        wrapper.style.height = `${scaledHeight}px`;
        
        // 调整页面定位
        page.style.transformOrigin = 'top center';
        page.style.position = 'absolute';
        page.style.left = '50%';
        page.style.transform = `translateX(-50%) scale(${scale})`;
      });
    }
  },
  mounted() {
    // 初始化时执行
    this.updatePageScale();
    
    // 监听窗口大小变化
    window.addEventListener('resize', this.updatePageScale);
    
    // 监听页面加载完成
    window.addEventListener('load', this.updatePageScale);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updatePageScale);
    window.removeEventListener('load', this.updatePageScale);
  }
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
}

/* 确保在所有设备上保持一致的缩放 */
.page-wrapper {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  position: relative;
}

.page {
  width: 1440px;
  transform-origin: top center;
  margin: 0 auto;
  position: relative;
}

.header {
  background-color: #4A90E2;
  padding: 20px 0;
  width: 100%;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}

.logo-container {
  display: flex;
  align-items: center;
}

.logo {
  width: 80px;
  height: 80px;
  margin-right: 15px;
  border-radius: 16px;
  background-color: #ffd900;
  padding: 10px;
}

.title {
  color: #fff;
  font-size: 36px;
  letter-spacing: 1px;
}

.main-content {
  width: 100%;
}

.hero-section {
  background-color: #4A90E2;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  overflow: visible;
}

.phone-container {
  flex-shrink: 0;
  width: 45%;
  max-width: 600px;
  position: relative;
  left: 10%;
  top: 3.59%; /* 调整手机向下的位置 */
  transform: translateY(0); /* 确保不会旋转 */
}

.phone-frame {
  position: relative;
  width: 100%;
  height: auto;
  transform: none; /* 确保不会旋转 */
}

.notch-background {
  position: absolute;
  top: 1%;
  left: 41%;
  width: 43.5%;
  height: 5%;
  background-color: #646464;
  z-index: 1;
}

.phone-screenshot {
  position: absolute;
  top: 5.1%;
  left: 18.1%;
  width: 89.4%;
  height: 80.8%;
  z-index: 1;
  object-fit: contain;
  border-radius: 30px;
  transform: none; /* 确保不会旋转 */
}

.phone-image {
  width: 100%;
  height: auto;
  display: block;
  position: relative;
  z-index: 2;
  transform: none; /* 确保不会旋转 */
}

.hero-text {
  color: #fff;
  width: 45%;
  padding-right: 10%;
  margin-top: 0;
  position: relative;
  z-index: 2;
}

.hero-text h1 {
  font-size: 36px;
  margin-bottom: 30px;
  letter-spacing: 2px;
  font-weight: 400;
}

.description p {
  font-size: 32px;
  margin: 12px 0;
  line-height: 1.5;
  letter-spacing: 1px;
}

.download-buttons {
  margin-top: 40px;
  display: flex;
  gap: 40px;
  justify-content: flex-start;
}

.download-btn {
  text-decoration: none;
  transition: transform 0.3s ease;
  background: none;
  padding: 0;
}

.download-img {
  width: 200px;
  height: auto;
  display: block;
  border-radius: 10px;
}

.download-btn:hover {
  transform: translateY(-2px);
}

.features-section {
  padding: 80px 40px;
  max-width: 1400px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  font-size: 48px;
  margin-bottom: 24px;
  color: #0e0e0e;
  
 
}

.section-subtitle {
  text-align: center;
  font-size: 28px;
  color: #454545;
  margin-bottom: 60px;
  
}

.features-container {
  display: flex;
  justify-content: space-between;
  gap: 50px;
  margin-top: 40px;
}

.feature-column {
  flex: 1;
}

.feature-column h3 {
  font-size: 32px;
  color: #333;
  margin-bottom: 24px;
  
}

.feature-text {
  font-size: 23px;
  line-height: 1.8;
  color: #666;

}

.feature-phone {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.phone-preview {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.phone-frame {
  width: 100%;
  height: auto;
  position: relative;
  z-index: 2;
}

.phone-content {
  position: absolute;
  top: 7.2%;
  left: 6.9%;
  width: 82.6%;
  height: 86.4%;
  z-index: 1;
  object-fit: contain;
  border-radius: 35px;
}

.mt-20 {
  margin-top: 50px;
}

.bottom-links {
  text-align: center;
  padding: 40px 0;
}

.bottom-links a {
  color: #333;
  text-decoration: none;
  margin: 0 24px;
  font-size: 28px;
  transition: color 0.3s ease;
}

.bottom-links a:hover {
  color: #4A90E2;
}

.footer {
  background-color: #202020;
  color: #999;
  text-align: center;
  padding: 24px;
}

.footer p {
  margin: 6px 0;
  font-size: 19px;
}

/* 添加全局字体设置 */
body {
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", "Microsoft YaHei", sans-serif;
}

/* 响应式设计 */
/* 移除所有媒体查询，改用 JS 控制缩放 */

/* 禁止图片拖动 */
img {
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -ms-user-drag: none;
  user-drag: none;
}
</style>
